import { Box, Container, Divider, Paper, Stack, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";
import Meta from "../Meta/Meta";
import content from "./imprintContent";

const ImprintPage = () => {
  const { i18n } = useTranslation();
  const language = i18n.language?.split("-")[0];
  const current = content[language] || content.en;
  const isArabic = language === "ar";

  return (
    <>
      <Meta
        title={`${current.title} | ALGermanist`}
        description={current.intro}
        keywords="imprint, impressum, legal notice, ALGermanist"
      />
      <Box sx={{ bgcolor: "#F7F9FA", direction: isArabic ? "rtl" : "ltr" }}>
        <Box
          sx={{
            minHeight: { xs: 330, md: 460 },
            display: "flex",
            alignItems: "center",
            color: "#fff",
            backgroundImage:
              "linear-gradient(180deg, rgba(0,0,0,.62), rgba(0,0,0,.62)), url('/home-heidelberg-bg.png')",
            backgroundSize: "cover",
            backgroundRepeat: "no-repeat",
            backgroundPosition: {
              xs: "38% 9%",
              sm: "42% 9%",
              md: "center 9%",
            },
          }}
        >
          <Container maxWidth="lg">
            <Stack spacing={2.5} sx={{ maxWidth: 820 }}>
              <Typography
                variant="overline"
                sx={{ color: "#FFD600", fontWeight: 900, letterSpacing: 0 }}
              >
                {current.langLabel}
              </Typography>
              <Typography
                variant="h1"
                sx={{
                  fontSize: { xs: "2.25rem", md: "4rem" },
                  fontWeight: 950,
                  lineHeight: 1.05,
                }}
              >
                {current.title}
              </Typography>
              <Typography
                sx={{
                  maxWidth: 720,
                  fontSize: { xs: "1rem", md: "1.2rem" },
                  lineHeight: 1.8,
                  opacity: 0.95,
                }}
              >
                {current.intro}
              </Typography>
            </Stack>
          </Container>
        </Box>

        <Container maxWidth="lg" sx={{ py: { xs: 5, md: 8 } }}>
          <Paper
            elevation={0}
            sx={{
              border: "1px solid #E4E7EC",
              borderRadius: 2,
              overflow: "hidden",
              bgcolor: "#fff",
            }}
          >
            <Box sx={{ p: { xs: 2.5, md: 4 } }}>
              <Typography
                variant="h2"
                sx={{
                  fontSize: { xs: "1.55rem", md: "2rem" },
                  fontWeight: 900,
                  color: "#101828",
                }}
              >
                {current.title}
              </Typography>
            </Box>
            <Divider />
            <Stack divider={<Divider />} sx={{ p: { xs: 2.5, md: 4 }, pt: 0 }}>
              {current.sections.map((section) => (
                <Box key={section.title} sx={{ py: { xs: 2.25, md: 3 } }}>
                  <Typography
                    variant="h3"
                    sx={{
                      fontSize: { xs: "1.1rem", md: "1.25rem" },
                      fontWeight: 900,
                      mb: 1.5,
                      color: "#101828",
                    }}
                  >
                    {section.title}
                  </Typography>
                  <Stack spacing={1.1}>
                    {section.body.map((paragraph) => (
                      <Typography
                        key={paragraph}
                        sx={{
                          color: "#344054",
                          lineHeight: 1.8,
                          fontSize: { xs: "0.96rem", md: "1rem" },
                          whiteSpace: "pre-line",
                        }}
                      >
                        {paragraph}
                      </Typography>
                    ))}
                  </Stack>
                </Box>
              ))}
            </Stack>
          </Paper>
        </Container>
      </Box>
    </>
  );
};

export default ImprintPage;
